import moment from 'moment';

export function fDate(date) {
    if (!date) return null;
    return moment(date).format('YYYY-MM-DD');
}